import React, {useEffect, useState} from 'react';
import {CardContent} from '@deere/fuel-react';
import {useStyles} from "../shared/styles/Summary";
import Accordion from "@material-ui/core/Accordion";
import {SummaryOptions} from './SummaryOptions';
import {SummaryRating} from './SummaryRating';
import {SummaryOptionsDetails} from './SummaryOptionsDetails';
import {SummaryRatingDetails} from './SummaryRatingDetails';
import {sortAlphaNum} from '../shared/utils';

export const SummaryCriteriaList = ({data, units, roles, names}) => {
    const classes = useStyles();
    const [expanded, setExpanded] = useState('panel1');
    const [updatedData, setUpdatedData] = useState([]);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : 'panel1');
    };

    const filterSummaryList = (item) => {
        const selectedUnitsData = units.map((item) => item.id)
        const selectedRolesData = roles.map((item) => item.id)
        const selectedStakeholderNamesData = names.map((item) => item.racfID)
        return item.feedbacks.filter(fb => {
            if (units.length === 0)
                return selectedRolesData.includes(fb.stakeholder.roles[0].id) &&
                    selectedStakeholderNamesData.includes(fb.stakeholder.user.racfID)
            else
                return selectedUnitsData.includes(fb.stakeholder.units.length > 0 && fb.stakeholder.units[0].id) &&
                    selectedRolesData.includes(fb.stakeholder.roles[0].id) &&
                    selectedStakeholderNamesData.includes(fb.stakeholder.user.racfID)
        })
    }

    const sortDesc = list => {
        return list && list.sort((a, b) => {
            let descA = a.criteria.toLowerCase(),
                descB = b.criteria.toLowerCase();
            return sortAlphaNum(descA, descB)
        })
    }

    const sortSubCategoryDesc = list => {
        return list && list.sort((a, b) => {
            let descA = a.subCategory && a.subCategory.description.toLowerCase(),
                descB = b.subCategory && b.subCategory.description.toLowerCase();
            return sortAlphaNum(descA, descB)
        })
    }

    useEffect(() => {
        const sortedData = sortDesc(data) && sortSubCategoryDesc(data)
        setUpdatedData(sortedData)
        return () => {
            setUpdatedData([data])
        }
    }, [data]);

    return (
        <>
            {updatedData && updatedData.map((item, index) => {
                const feedbackList = filterSummaryList(item)
                const maxStars = item.responseType.id === 2 ? 5 :
                    item.responseType.id === 4 ? item.custLikertRanges.length : 0;
                return (
                    <CardContent style={{padding: 0, marginTop: 10}} key={index}>
                        <div className={classes.root}>
                            <Accordion expanded={expanded === `panel${item.id}`}
                                       onChange={handleChange(`panel${item.id}`)}>
                                {item.responseType.id === 1 ?
                                    <SummaryOptions
                                        classes={classes}
                                        item={item}
                                        feedbackList={feedbackList}
                                    /> :
                                    item.responseType.id === 2 || item.responseType.id === 4 ?
                                        <SummaryRating
                                            classes={classes}
                                            item={item}
                                            feedbackList={feedbackList}
                                        /> : <></>
                                }
                                {item.responseType.id === 1 ?
                                    <SummaryOptionsDetails
                                        classes={classes}
                                        feedbackList={feedbackList}/> :
                                    item.responseType.id === 2 || item.responseType.id === 4 ?
                                        <SummaryRatingDetails
                                            classes={classes}
                                            feedbackList={feedbackList}
                                            maxStars={maxStars}
                                        /> : <></>
                                }
                            </Accordion>
                        </div>
                    </CardContent>
                )
            })
            }
        </>
    )
}